import type { IClientLimitsFilterInput } from 'src/common'

export const defaultFilter: IClientLimitsFilterInput = {
  klantNummer: undefined,
  klantNaam: undefined,
  overLimit: false,
}
